module.exports = __webpack_public_path__ + "static/banner-autres-mobile-7e94b52492d31e896345dc8bea7a1804.jpg";